import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8 flex justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "p-6 text-center text-red-600 font-semibold"
}
const _hoisted_3 = {
  key: 2,
  class: "p-6 space-y-5"
}
const _hoisted_4 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_7 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}
const _hoisted_8 = {
  key: 0,
  class: "text-sm text-red-600 mt-1"
}

import { ref, watch, computed } from "vue";
import { useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/yup";
import * as yup from "yup";
import AdminModalShell from "@/share/components/admin/AdminModalShell.vue";
import AdminModalHeader from "@/share/components/admin/AdminModalHeader.vue";
import AdminModalFooter from "@/share/components/admin/AdminModalFooter.vue";
import AdminButton from "@/share/components/admin/AdminButton.vue";
import { useModeloVehiculoFindOne } from "../../composables/modeloVehiculoComposables";
import { ModeloVehiculoCreateInterface } from "../../interfaces/modelovehiculosinterfaces/ModeloVehiculoCreate.interface";
import { useMarcaVehiculoSelect } from "../../composables/marcaVehiculosComposables/useMarcaVehiculoSelect";

interface Props {
  isOpen: boolean;
  modeloId?: string;
  isSaving?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FormularioModeloVehiculo',
  props: {
    isOpen: { type: Boolean },
    modeloId: {},
    isSaving: { type: Boolean, default: false }
  },
  emits: ["close", "save", "update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const schema = toTypedSchema(
  yup.object({
    nombreModelo: yup
      .string()
      .required("El nombre del modelo es obligatorio")
      .trim()
      .min(3, "Debe tener al menos 3 caracteres")
      .max(50, "No puede exceder 50 caracteres"),
    descripcionModelo: yup
      .string()
      .optional()
      .default("")
      .test(
        "desc-len",
        "La descripción no puede exceder 200 caracteres",
        (val) => !val || String(val).trim().length <= 200
      ),
    añoModelo: yup
      .string()
      .required("El año es obligatorio")
      .matches(/^\d{4}$/, "Debe tener 4 dígitos numéricos (ej: 2025)"),
    versionModelo: yup
      .string()
      .optional()
      .default("")
      .max(50, "La versión no puede exceder 50 caracteres"),
    idMarcaVehiculo: yup.string().required("Debes seleccionar una marca"),
  })
);

const { defineField, errors, handleSubmit, meta, resetForm, setValues } =
  useForm({
    validationSchema: schema,
    initialValues: {
      nombreModelo: "",
      descripcionModelo: "",
      añoModelo: "",
      versionModelo: "",
      idMarcaVehiculo: "",
    },
  });

const [nombreModelo, nombreModeloAttrs] = defineField("nombreModelo");
const [descripcionModelo, descripcionModeloAttrs] =
  defineField("descripcionModelo");
const [añoModelo, añoModeloAttrs] = defineField("añoModelo");
const [versionModelo, versionModeloAttrs] = defineField("versionModelo");
const [idMarcaVehiculo, idMarcaVehiculoAttrs] =
  defineField("idMarcaVehiculo");

const { marcas } = useMarcaVehiculoSelect();

const modeloIdRef = computed(() => props.modeloId || "");
const {
  data: modeloData,
  isPending,
  isError,
} = useModeloVehiculoFindOne(modeloIdRef);
const isEditMode = computed(() => !!props.modeloId);

watch(
  modeloData,
  (newData) => {
    const modelo = newData?.data?.data;
    if (modelo && typeof modelo === "object") {
      setValues({
        nombreModelo: modelo.nombreModelo || "",
        descripcionModelo: modelo.descripcionModelo || "",
        añoModelo: modelo.añoModelo || "",
        versionModelo: modelo.versionModelo || "",
        idMarcaVehiculo: modelo.idMarcaVehiculo || "",
      });
    }
  },
  { immediate: true, deep: true }
);

watch(
  () => props.isOpen,
  (isOpen) => {
    if (!isOpen) {
      if (!isEditMode.value) limpiarCampos();
    }
  }
);

function limpiarCampos() {
  resetForm({
    values: {
      nombreModelo: "",
      descripcionModelo: "",
      añoModelo: "",
      versionModelo: "",
      idMarcaVehiculo: "",
    },
  });
}

const handleSave = handleSubmit((vals) => {
  const Modelo: ModeloVehiculoCreateInterface = {
    nombreModelo: vals.nombreModelo.trim(),
    descripcionModelo: vals.descripcionModelo.trim(),
    añoModelo: vals.añoModelo.trim(),
    versionModelo: vals.versionModelo.trim(),
    idMarcaVehiculo: vals.idMarcaVehiculo,
  };

  if (isEditMode.value && props.modeloId)
    emit("update", props.modeloId, Modelo);
  else emit("save", Modelo);
});

const handleClose = () => {
  limpiarCampos();
  emit("close");
};

const opcionesMarcaVehiculo = computed(() => {
  return marcas.value.map((m) => ({
    label: m.nombreMarca,
    value: m.id,
  }));
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (__props.isOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-40 flex items-center justify-center p-4",
            onClick: _withModifiers(handleClose, ["self"])
          }, [
            _createVNode(_Transition, { name: "scale" }, {
              default: _withCtx(() => [
                (__props.isOpen)
                  ? (_openBlock(), _createBlock(AdminModalShell, {
                      key: 0,
                      "max-width-class": "max-w-2xl"
                    }, {
                      header: _withCtx(() => [
                        _createVNode(AdminModalHeader, {
                          variant: "dark",
                          title: 
                isEditMode.value
                  ? 'Editar Modelo de Vehículo'
                  : 'Nuevo Modelo de Vehículo'
              ,
                          onClose: handleClose
                        }, {
                          icon: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("svg", {
                              class: "w-7 h-7",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
                              })
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["title"])
                      ]),
                      footer: _withCtx(() => [
                        _createVNode(AdminModalFooter, { "rounded-bottom": "" }, {
                          default: _withCtx(() => [
                            _createVNode(AdminButton, {
                              variant: "secondary",
                              onClick: handleClose
                            }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode(" Cancelar ", -1)
                              ]))]),
                              _: 1
                            }),
                            _createVNode(AdminButton, {
                              variant: "primary",
                              disabled: 
                  !_unref(meta).valid || (_unref(isPending) && isEditMode.value) || props.isSaving
                ,
                              loading: props.isSaving,
                              onClick: _unref(handleSave)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(props.isSaving
                    ? "Guardando…"
                    : isEditMode.value
                      ? "Actualizar"
                      : "Guardar"), 1)
                              ]),
                              _: 1
                            }, 8, ["disabled", "loading", "onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        (_unref(isPending) && isEditMode.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[6] || (_cache[6] = [
                              _createElementVNode("div", { class: "animate-spin h-12 w-12 border-b-2 border-red-600 rounded-full" }, null, -1)
                            ]))]))
                          : (_unref(isError) && isEditMode.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Error al cargar el modelo "))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
                                    _createTextVNode(" Nombre del Modelo "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(nombreModelo) ? (nombreModelo).value = $event : null))
                                  }, _unref(nombreModeloAttrs), {
                                    type: "text",
                                    placeholder: "Ej: Corolla, Civic, Hilux...",
                                    maxlength: "50",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).nombreModelo ? 'border-red-400' : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(nombreModelo)]
                                  ]),
                                  (_unref(errors).nombreModelo)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errors).nombreModelo), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, "Descripción", -1)),
                                  _withDirectives(_createElementVNode("textarea", _mergeProps({
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(descripcionModelo) ? (descripcionModelo).value = $event : null))
                                  }, _unref(descripcionModeloAttrs), {
                                    rows: "3",
                                    maxlength: "200",
                                    placeholder: "Descripción breve del modelo...",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl resize-none outline-none transition-all", 
                  _unref(errors).descripcionModelo
                    ? 'border-red-400'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(descripcionModelo)]
                                  ]),
                                  (_unref(errors).descripcionModelo)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(errors).descripcionModelo), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
                                    _createTextVNode("Año "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(añoModelo) ? (añoModelo).value = $event : null))
                                  }, _unref(añoModeloAttrs), {
                                    type: "text",
                                    maxlength: "4",
                                    placeholder: "Ej: 2025",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).añoModelo ? 'border-red-400' : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(añoModelo)]
                                  ]),
                                  (_unref(errors).añoModelo)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(errors).añoModelo), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, "Versión", -1)),
                                  _withDirectives(_createElementVNode("input", _mergeProps({
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(versionModelo) ? (versionModelo).value = $event : null))
                                  }, _unref(versionModeloAttrs), {
                                    type: "text",
                                    maxlength: "50",
                                    placeholder: "Ej: Sport, Hybrid, Limited...",
                                    class: ["w-full px-4 py-3 border-2 rounded-xl outline-none transition-all", 
                  _unref(errors).versionModelo
                    ? 'border-red-400'
                    : 'border-slate-200 focus:border-blue-500'
                ]
                                  }), null, 16), [
                                    [_vModelText, _unref(versionModelo)]
                                  ]),
                                  (_unref(errors).versionModelo)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(errors).versionModelo), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block text-sm font-semibold text-slate-700 mb-2" }, [
                                    _createTextVNode(" Marca "),
                                    _createElementVNode("span", { class: "text-red-500" }, "*")
                                  ], -1)),
                                  _createVNode(_component_v_select, _mergeProps({
                                    modelValue: _unref(idMarcaVehiculo),
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(idMarcaVehiculo) ? (idMarcaVehiculo).value = $event : null))
                                  }, _unref(idMarcaVehiculoAttrs), {
                                    options: opcionesMarcaVehiculo.value,
                                    reduce: (option) => option.value,
                                    label: "label",
                                    placeholder: "Selecciona una marca...",
                                    "append-to-body": true,
                                    class: ["custom-v-select", _unref(errors).idMarcaVehiculo ? 'border-red-400' : '']
                                  }), null, 16, ["modelValue", "options", "reduce", "class"]),
                                  (_unref(errors).idMarcaVehiculo)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_unref(errors).idMarcaVehiculo), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})